import getters from './getters'
import mutations from './mutations'
import actions from './actions'

export const overwatch = {
  namespaced: true,
  state: {
    booking: '',
    bookingForm: '',
    isReturnBooking: false,
    bookingChangelog: '',
    includeUnconfirmedBookings: true,
    bookingTypesFilter: '',
    customerIdFilter: ''
  },
  getters,
  mutations,
  actions
}
